var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50978 1.79178L4.10178 4.88889H1.83333C1.3471 4.88889 0.880788 5.08204 0.536971 5.42586C0.193154 5.76968 0 6.23599 0 6.72222V9.02244L0.614778 9.32922C3.83929 10.9415 7.39489 11.7808 11 11.7808C14.6051 11.7808 18.1607 10.9415 21.3852 9.32922L22 9.02244V6.72222C22 6.23599 21.8068 5.76968 21.463 5.42586C21.1192 5.08204 20.6529 4.88889 20.1667 4.88889H17.8982L16.4902 1.79178C16.2475 1.25755 15.8562 0.804494 15.3629 0.486756C14.8696 0.169018 14.2952 3.44424e-05 13.7084 0H8.29156C7.70479 3.44424e-05 7.13043 0.169018 6.63714 0.486756C6.14384 0.804494 5.75247 1.25755 5.50978 1.79178ZM8.29156 2.44444C8.17427 2.44448 8.05947 2.47826 7.96086 2.54176C7.86225 2.60526 7.784 2.69579 7.73544 2.80256L6.787 4.88889H15.213L14.2646 2.80256C14.216 2.69579 14.1377 2.60526 14.0391 2.54176C13.9405 2.47826 13.8257 2.44448 13.7084 2.44444H8.29156Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22 11.749C18.9347 13.2037 15.6113 14.0358 12.2222 14.1971V15.8887C12.2222 16.2128 12.0935 16.5237 11.8642 16.7529C11.635 16.9821 11.3242 17.1109 11 17.1109C10.6758 17.1109 10.365 16.9821 10.1358 16.7529C9.90655 16.5237 9.77778 16.2128 9.77778 15.8887V14.1971C6.42889 14.037 3.10444 13.2218 0 11.749V20.1665C0 20.6527 0.193154 21.119 0.536971 21.4628C0.880788 21.8066 1.3471 21.9998 1.83333 21.9998H20.1667C20.6529 21.9998 21.1192 21.8066 21.463 21.4628C21.8068 21.119 22 20.6527 22 20.1665V11.749Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobIcon);
export default __webpack_public_path__ + "static/media/jobIcon.56c4154b7af9380f26ebc30ae22db328.svg";
export { ForwardRef as ReactComponent };